import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Heart, BookOpen, Smile, Sparkles } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export default function About() {
  const { t } = useSettings();
  useEffect(() => { document.title = "About – Cheap4Teach"; }, []);
  return (
    <div className="max-w-5xl mx-auto px-6 py-12" data-testid="about-page">
      <span className="c4t-badge">{t("about.eyebrow", "Our Story")}</span>
      <h1 className="text-4xl sm:text-5xl font-['Fredoka'] font-bold mt-4">{t("about.title", "Made by Teachers, for Teachers")}</h1>
      <div className="grid md:grid-cols-2 gap-10 mt-10">
        <div className="space-y-4 text-base sm:text-lg c4t-desc leading-relaxed">
          <p>{t("about.p1")}</p>
          <p>{t("about.p2")}</p>
          <p>{t("about.p3")}</p>
        </div>
        <div className="relative mx-auto max-w-md aspect-square rounded-[3rem] overflow-hidden">
          <img src="/about-illustration.png" alt="Cheap4Teach illustration" className="w-full h-full object-cover" />
        </div>
      </div>

      <div className="grid sm:grid-cols-3 gap-5 mt-12">
        {[
          { icon: <Heart className="w-7 h-7" strokeWidth={2.5}/>, color: "#FF1F87", titleKey: "about.value1.title", descKey: "about.value1.desc" },
          { icon: <BookOpen className="w-7 h-7" strokeWidth={2.5}/>, color: "#00E0AA", titleKey: "about.value2.title", descKey: "about.value2.desc" },
          { icon: <Smile className="w-7 h-7" strokeWidth={2.5}/>, color: "#FFC500", titleKey: "about.value3.title", descKey: "about.value3.desc" },
        ].map(v => (
          <div key={v.titleKey} className="c4t-card">
            <span className="rounded-full p-3 inline-flex border-[3px] border-black" style={{ background: v.color, color: v.color === "#FFC500" ? "#000" : "#fff" }}>{v.icon}</span>
            <h3 className="mt-3 text-xl font-['Fredoka'] font-bold">{t(v.titleKey)}</h3>
            <p className="c4t-desc mt-1">{t(v.descKey)}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 c4t-card text-center !bg-white">
        <Sparkles className="w-8 h-8 text-[#FFC500] mx-auto" />
        <h2 className="text-2xl font-['Fredoka'] font-bold mt-2">{t("about.cta_title", "Ready to Brighten Your Classroom?")}</h2>
        <Link to="/shop" className="mt-4 inline-flex c4t-btn c4t-btn-pink" data-testid="about-shop-btn">{t("about.cta_button", "Shop Now")}</Link>
      </div>
    </div>
  );
}
